import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import './NavBar.scss';
import { Icon, Avatar, Tooltip } from '@material-ui/core';
import { connect } from 'react-redux';
import TVModeModal from './TVModeModal';
import ProfileMenu from './ProfileMenu';
import { signOut } from '../../actions/AuthActions';
import { toggleAdminModal } from '../../actions/AdminActions';

// const MIN_HEIGHT = 80;
// const MAX_HEIGHT = 110;

class NavBar extends Component {
  self = this;
  bar = null;
  container = null;
  state = {
    isProfileShown: false
  };

  logo = null;
  links = null;
  extras = null;
  tvModal = null;
  avatar = null;

  findTriangleLocation() {
    if (!this.avatar) return 78;
    // will usually equal 67 if the screen is big enough
    const distToRight = this.extras.getBoundingClientRect().right - this.avatar.getBoundingClientRect().right;
    // 78 is default marginLeft for distToRight = 67, add 1 pixel margin for everypixel smaller distToRight is
    let triangleMarginLeft = 78 + Math.max(0, 93 - distToRight);
    //when nav changes styles (690px screen size) the triangle is just barely offset, so we add 3
    if (distToRight < 23.9) triangleMarginLeft += 3;
    return triangleMarginLeft;
  }

  render() {
    const { history, currentUser } = this.props;
    const photoURL = currentUser ? currentUser.picture : '';
    const { pathname } = history.location;

    const hoverHolderClass = this.state.isProfileShown ? 'hover-holder' : 'hover-holder hide-element';

    return (
      <div id="nav-bar" ref={ref => this.bar = ref}>
        <div ref={(ref) => this.logo = ref} className="logo link-wrapper">
          <Link to="/shoutouts">
            <img alt="logo" src={require('../../assets/img/prism-logo.png')} />
          </Link>
        </div>

        <div ref={(ref) => this.links = ref} className="links">
          <div className="link-wrapper">
            <Link className={(pathname.indexOf('/shoutouts') !== -1 && pathname.indexOf('/profile') === -1) ? 'active' : ''} to="/shoutouts">Shoutouts</Link>
          </div>
          <div className="link-wrapper">
            <Link className={pathname === '/users' ? 'active' : ''} to="/users">Users</Link>
          </div>
        </div>

        <div ref={(ref) => this.extras = ref} className="extras">
          <div className="link-wrapper tv-wrapper">
            <Tooltip title="TV Mode">
              <Icon fontSize="large"
                onClick={() => {this.tvModal.getWrappedInstance().showModal();}}>tv</Icon>
            </Tooltip>
          </div>

          <div ref={(ref) => this.avatar = ref} style={{ position: 'relative' }}>
            <Avatar onMouseEnter={() => {this.setState({ isProfileShown: true }); }}
              onClick={() => this.setState({ isProfileShown: !this.state.isProfileShown })}
              className="large user-icon" alt="sender" src={photoURL} />
            {currentUser && currentUser.unread !== 0 && <div className="pink-circle"/>}
          </div>
          <span className={hoverHolderClass}
            onMouseLeave={() => this.setState({ isProfileShown: false })}>
            <ProfileMenu
              adminTools={this.props.toggleAdminModal}
              isShown={this.state.isProfileShown}
              currentUser={currentUser}
              triangleLocation={this.findTriangleLocation()}
              signOut={this.props.signOut.bind(this)}
            />
          </span>
        </div>

        <TVModeModal ref={(ref) => this.tvModal = ref} openTVMode={() => history.push('/tv')}/>

      </div>
    );
  }
}

const mapStateToProps = ({ usersStore }) => {
  const { currentUser } = usersStore;

  return { currentUser };
};

export default withRouter(connect(mapStateToProps, { signOut, toggleAdminModal })(NavBar));



// WEBPACK FOOTER //
// ./src/screens/dashboard/NavBar.js